// extracted by mini-css-extract-plugin
export default {"container":"CsZL1rlE","title":"auAkZ5ix"};